import HTTP from '@/api/HTTP';
import transformerMateriel
  from '@/services/gabed/materiel/filter/materielServerTableDataTransformer';

const URL_BASE = 'patri/Materiel/';

export async function create(materielInformation) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', materielInformation);
  return response;
}

export async function get(idMateriel) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idMateriel } });
  return response;
}

export async function getByProduitsIds(idMateriel) {
  const response = await HTTP.post(URL_BASE + 'PGetMaterielByProduitsIdsAsync', { produitsIds: idMateriel });
  return response;
}

export async function update(materielInformation) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', materielInformation);
  return response;
}

export async function synchroniserLogoMateriel(params) {
  const response = await HTTP.post(URL_BASE + 'SynchroniserLogoAsync', params);
  return response;
}

export async function synchroniserLogoMaterielAll(params) {
  const response = await HTTP.post(URL_BASE + 'SynchroniserLogoAllAsync', params);
  return response;
}

export async function getAll(param) {
  const inputServer = transformerMateriel(param);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function calculTlpeJour(informationProduit) {
  const response = await HTTP.post(URL_BASE + 'CalculTlpeJourAsync', informationProduit);
  return response;
}

export async function calculTlpeSemaine(informationProduit) {
  const response = await HTTP.post(URL_BASE + 'CalculTlpeSemaineAsync', informationProduit);
  return response;
}

export async function calculTlpeSemaineFaces(params) {
  const response = await HTTP.post(URL_BASE + 'CalculTlpeSemaineFacesAsync', params);
  return response;
}

export async function updateTlpeFields(params) {
  const response = await HTTP.post(URL_BASE + 'PUpdateTlpeFieldsAsync', params);
  return response;
}

export async function deplacerAsync(params) {
  const response = await HTTP.post(URL_BASE + 'DeplacerAsync', params);
  return response;
}

export async function getCountDeclarableAsync(params) {
  const response = await HTTP.post(URL_BASE + 'PGetCountDeclarableAsync', params);
  return response;
}

export async function getCountDeclarableAuFilDeLeauAsync(params) {
  const response = await HTTP.post(URL_BASE + 'PGetCountDeclarableAuFilDeLeauAsync', params);
  return response;
}

export async function generationDeclarationsTlpeAsync(params) {
  const response = await HTTP.post(URL_BASE + 'PGenerationDeclarationsTlpeAsync', params);
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function supprimer(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function dupliquer(id) {
  const response = await HTTP.post(URL_BASE + 'DupliquerAsync', { id: id });
  return response;
}
